<header class="text-gray-600 body-font">
    <div id="not-logged-header"
        class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center justify-between rounded-b-lg w-full">
        <!-- Alterado para w-full -->
        <span class="text-white text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent mollis enim at
            dolor.</span>
        <div class="px-10 flex gap-4 flex-wrap mx-auto mt-5 justify-center">

            <a class="inline-flex items-center py-2 px-5 focus:outline-none rounded-lg text-base mt-4 md:mt-0 border-2 border-[var(--lightBlue)] bg-[var(--lightBlueBk)] hover:bg-white"
            [routerLink]="['/login']">
                Entrar
            </a>

            <a class="inline-flex items-center bg-[var(--lightRed)] border-0 py-2 px-5 focus:outline-none hover:bg-yellow-400 rounded-lg text-base mt-4 md:mt-0 text-[var(--darkPurple)] font-medium"
            [routerLink]="['/signup']">
                Assinar agora
            </a>
        </div>
    </div>
</header>